module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/join-3-05ce16d1117cd9bc6879eb05de36be7d.svg";